import React, { useEffect, useState } from 'react'
import {
    Grid,
    makeStyles,
    FormControl,
    Button,
    Box,
    FormControlLabel,
    Checkbox,
    FormLabel,
    Typography,
    Paper,
    IconButton
} from '@material-ui/core';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useDispatch, useSelector } from 'react-redux';
import ProfileUpdateInfo from '../../components/ProfileUpdateInfo/ProfileUpdateInfo';
import { addAnotherOrganization, getOrganizationList } from '../../store/action';
import { apiClient } from '../../config/apiClient';
import Notify from '../../components/Notify/Notify';
import CloseIcon from '@material-ui/icons/Close';
import Loading from '../../components/Loading';


const useStyle = makeStyles((theme) => ({
    section: {
        marginBottom: theme.spacing(3),
    },
    sectionHeader: {
        display: "flex",
        justifyContent:"space-between",
        alignItems: "center",
    },
    orgCard: {
        marginBottom: theme.spacing(3),
        position: "relative",
    },
    removeOrg: {
        position: "absolute",
        top: 8,
        right: 12,
        cursor: "pointer",
        zIndex: 10,
        color: theme.palette.error.main,
        backgroundColor: "rgba(255,0,0,0.05)",
        "&:hover": {
            backgroundColor: "rgba(255,0,0,0.1)",
        },
    },
    registerBtn: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center"
    },
    formLabel: {
        fontWeight: 600,
        color: theme.palette.text.primary,
    },
    title: {
        color: theme.palette.text.primary,
    },
}));


const AddOrganization = () => {
    const classes = useStyle();
    const dispatch = useDispatch()
    const [orgId, setOrgId] = useState()
    const [orgIndex, setOrgIndex] = useState(0)
    const { getOrglist, addOrgSuccess, addOrgError, loading } = useSelector(state => state.organization)
    const [addOrgNotify, setAddOrgNotify] = useState(false)

    const [formError, setFormError] = useState([]);
    const [data, setData] = useState({
        organization: [
            {
                organization_id: "",
                speciality: [],
                other_speciality_list: []
            },
        ]
    })

    const handleChangeHospital = (index, event, key, value) => {
        let orgValue = value ? value.id : ''
        const organizationData = JSON.parse(JSON.stringify(data));

        organizationData[key][index]['organization_id'] = orgValue
        organizationData[key][index].speciality = []
        organizationData[key][index].other_speciality_list = []

        let formErrorList = JSON.parse(JSON.stringify(formError));
        if (orgValue) {
            // remove organization id error 
            const removeIndex = formErrorList.indexOf(`organization_id_error_${index}`);
            if (removeIndex > -1) {
                formErrorList.splice(removeIndex, 1);
            }
        } else {
            // create organization id error
            formErrorList.push(`organization_id_error_${index}`)
            // remove speciality error
            const removeIndex = formErrorList.indexOf(`speciality_error_${index}`);
            if (removeIndex > -1) {
                formErrorList.splice(removeIndex, 1);
            }
        }
        setOrgIndex(index);
        setData(organizationData);
        setOrgId(orgValue)
        setFormError(formErrorList)
    };

    const addOrganization = () => {
        const organizationData = JSON.parse(JSON.stringify(data));
        organizationData.organization.push(
            {
                organization_id: "",
                speciality: [],
                other_speciality_list: []
            }
        )
        setData(organizationData)
    }

    const removeOrg = (index) => {
        const org = JSON.parse(JSON.stringify(data));
        if (org.organization.length > 1) {
            org.organization.splice(index, 1)
            setData(org)
        }

        const formErrorList = JSON.parse(JSON.stringify(formError));

        const removeIndex1 = formErrorList.indexOf(`organization_id_error_${index}`);
        if (removeIndex1 > -1) {
            formErrorList.splice(removeIndex1, 1);
        }
        const removeIndex = formErrorList.indexOf(`speciality_error_${index}`);
        if (removeIndex > -1) {
            formErrorList.splice(removeIndex, 1);
        }
        setFormError(formErrorList);
    }

    useEffect(() => {
        dispatch(getOrganizationList())
    }, [])

    const getSpecialities = async () => {
        if (orgId) {
            await apiClient(true).get(`api/signee/get-org-specialities/${orgId}`)
                .then(response => {
                    if (response.data.status === true) {
                        const specialityData = JSON.parse(JSON.stringify(data));
                        specialityData.organization[orgIndex].other_speciality_list = response.data.data;
                        setData(specialityData)
                    }
                }).catch(error => {
                    console.log('error: ', error);
                })
        }
    }

    useEffect(() => {
        getSpecialities()
    }, [orgId])

    const formValidate = () => {
        let allError = []

        data && data.organization.map((list, index) => {
            if (list.organization_id === "") {
                allError.push(`organization_id_error_${index}`)
            }
            if (list.speciality.length === 0) {
                allError.push(`speciality_error_${index}`)
            }
        })
        return allError;
    }

    const handleSubmit = () => {
        let allError = formValidate();
        if (allError.length === 0) {
            dispatch(addAnotherOrganization(data))
            setAddOrgNotify(true)
        } else {
            setFormError(allError);
        }
    }

    const handleChangeCheck = (event, index, speIndex) => {
        const specialityData = JSON.parse(JSON.stringify(data));
        const isChecked = (event.target.checked);
        const formErrorList = JSON.parse(JSON.stringify(formError));

        if (isChecked) {
            specialityData.organization[index].speciality.push(parseFloat(event.target.value));
        } else {
            let newSpeData = specialityData.organization[index].speciality.filter(item => item !== parseFloat(event.target.value))
            specialityData.organization[index].speciality = newSpeData
        }

        // hide show error msg for speciality
        if (specialityData.organization[index].speciality.length === 0) {
            // create speciality error
            formErrorList.push(`speciality_error_${index}`)
        } else {
            // remove speciality error
            const removeIndex = formErrorList.indexOf(`speciality_error_${index}`);
            if (removeIndex > -1) {
                formErrorList.splice(removeIndex, 1);
            }
        }
        setData(specialityData)
        setFormError(formErrorList);
    };

    const getOptionDisabledOrgList = (option) => {
        let defaultSelect = false;
        let obj = data.organization.find(o => o.organization_id === option.id);
        if (obj) {
            defaultSelect = true;
        }
        return defaultSelect;
    }

    const orgOptionList = () => {
        let returnList = getOrglist?.data && getOrglist?.data ? getOrglist?.data.sort((a, b) => (a.organization_name > b.organization_name) ? 1 : -1) : []
        return returnList;
    }

    return (
        <>
            {loading && <Loading open={loading} />}

            {addOrgNotify && (addOrgError?.message || addOrgError) &&
                <Notify data={addOrgError?.message ? addOrgError?.message : addOrgError} status="error"/>
            }

            {addOrgNotify && (addOrgSuccess?.message || addOrgSuccess) &&
                <Notify data={addOrgSuccess?.message ? addOrgSuccess?.message : addOrgSuccess} status="success"/>
            }

            <ProfileUpdateInfo />

            <Paper className={classes.section}>
                <Box className={classes.sectionHeader}>
                    <Typography variant="h5" className={classes.title}>Add Organization</Typography>
                    
                    <Button
                        onClick={addOrganization}
                        variant="outlined"
                        startIcon={<AddCircleOutlineIcon />}
                        className={classes.addBtn}
                    >
                        Add Another Organization
                    </Button>
                </Box>
            </Paper>

                {data.organization.map((list, index) => (
                    <Paper elevation={1} className={classes.orgCard} key={index}>
                        {/* Remove Organization */}
                        {index !== 0 && (
                            <IconButton className={classes.removeOrg} onClick={() => removeOrg(index)}>
                                <CloseIcon />
                            </IconButton>
                        )}

                        <Grid container spacing={3}>
                            {/* Organization Autocomplete */}
                            <Grid item xs={12} sm={4}>
                                <Autocomplete
                                    id={`org-autocomplete-${index}`}
                                    options={orgOptionList()}
                                    getOptionDisabled={getOptionDisabledOrgList}
                                    name="organization_id"
                                    getOptionLabel={(option) =>
                                        option.organization_name || ""
                                    }
                                    onChange={(e, value) =>
                                        handleChangeHospital(index, e, "organization", value)
                                    }
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            label="Select Organization"
                                            error={formError.includes(
                                                `organization_id_error_${index}`
                                            )}
                                            fullWidth
                                        />
                                    )}
                                />
                            </Grid>

                            {/* Speciality Checkboxes */}
                            <Grid item xs={12} sm={8}>
                                <FormControl
                                    component="fieldset"
                                    required
                                    error={formError.includes(`speciality_error_${index}`)}
                                    fullWidth
                                >
                                    <FormLabel
                                        component="legend"
                                        className={classes.formLabel}
                                    >
                                        Select Speciality
                                    </FormLabel>
                                    <Box className={classes.specialityBox}>
                                        {list.other_speciality_list?.length > 0 ? (
                                            list.other_speciality_list.map((spec, speIndex) => (
                                                <FormControlLabel
                                                key={speIndex}
                                                control={
                                                    <Checkbox
                                                        color="primary"
                                                        value={spec.id}
                                                        checked={list.speciality?.includes(spec.id)}
                                                        onChange={(e) => handleChangeCheck(e, index, speIndex)}
                                                        name="speciality"
                                                    />
                                                }
                                                label={spec.speciality_name}
                                                />
                                            ))
                                        ) : (
                                            <Typography variant="body2" className={classes.infoText}>
                                                No specialities found
                                            </Typography>
                                        )}
                                    </Box>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Paper>
                ))}

                
                {/* Submit Button */}
                <Box className={classes.registerBtn}>
                    <Button variant="contained" onClick={handleSubmit}>Register</Button>
                </Box>
            
        </>
    )
}

export default AddOrganization
